import { Typography } from "@mui/material";
import { languageDirections } from "../../../constants/languageCodes";
import { useAppSelector } from "../../../hooks";

interface CustomLabelProps {
  label: string;
}
const CustomLabel: React.FC<CustomLabelProps> = ({ label }) => {
  const direction = useAppSelector((state) => state.languageSlice.direction);
  return (
    <Typography
      sx={{
        color: "#707083",
        fontSize: 14,
        fontFamily: "Poppins",
        textAlign: direction === languageDirections.ltr ? "left" : "right",
        textTransform: "uppercase",
      }}
    >
      {label}
    </Typography>
  );
};

export default CustomLabel;
